class iRem {
    constructor() {

    }
    static install(doc) {
        // var userAgentInfo = navigator.userAgent;
        // var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone", "iPod", "iPad"];
        // var flag = true;
        // for (var v = 0; v < Agents.length; v++) {
        //     if (userAgentInfo.indexOf(Agents[v]) > 0) {
        //         flag = false;
        //         break;
        //     }
        // }
        // if(flag) return;

        var docEl = doc.documentElement,
            // resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
            isPad = window.screen.width >= 768;
        // function recalc() {
        //     console.log(isPad, 'isPad')
        //     var clientWidth = docEl.clientWidth;
        //     if (!clientWidth) return;
        //     isPad ? docEl.style.fontSize = 100 * (clientWidth / 768) + 'px' : docEl.style.fontSize = 100 * (clientWidth / 375) + 'px';
        // };
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        isPad ? docEl.style.fontSize = 100 * (clientWidth / 768) + 'px' : docEl.style.fontSize = 100 * (clientWidth / 375) + 'px';
        // if (!doc.addEventListener) return;
        // win.addEventListener(resizeEvt, recalc, false);
        // doc.addEventListener('DOMContentLoaded', recalc, false);
    }
}
export default iRem;